import React, { createRef } from 'react';
import { createRoot } from 'react-dom/client';
import HekateTextViewer from './HekateTextViewer';
window.mountHekateTextViewer = function mountHekateTextViewer(containerId, props) {
    const container = document.getElementById(containerId);
    if (!container) {
        console.error('HekateTextViewer: container not found:', containerId);
        return {
            type: 'text',
            unmount: () => { },
            get api() { return null; },
        };
    }
    const apiRef = createRef();
    const root = createRoot(container);
    root.render(React.createElement(HekateTextViewer, { ...props, ref: apiRef }));
    return {
        type: 'text',
        unmount: () => root.unmount(),
        get api() { return apiRef.current; },
    };
};
